import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_event,
  add_event,
  update_event,
  delete_event,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    event: [],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  filterData:{
    month:"",
    year:""
  },
  formData: {
    date:"",
    title :"",
    description:""
  },
};

// Async Thunks for API Calls
export const fetchevent = createAsyncThunk(
  "event/fetchevent",
  async ({ page, page_size,school_id,month,year, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_event(page, page_size,school_id,month,year, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createevent = createAsyncThunk(
  "event/createevent",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_event(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateevent = createAsyncThunk(
  "event/updateevent",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_event(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteevent = createAsyncThunk(
  "event/deleteevent",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_event({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// event Slice
const eventSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, date,title,description } = action.payload;
      state.formData = { id,date,title,description  };
    },
    resetFormData(state) {
      state.formData = {
        date:"",
        description :"",
    title:""
      };
    },
    setEvent(state, action) {
      state.event = action.payload;
    },
    setFilterData(state,action){
        state.filterData = action.payload
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
   
       // Fetch event
       .addCase(fetchevent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchevent.fulfilled, (state, action) => {
        state.loading = false;
        state.event = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchevent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add event
      .addCase(createevent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createevent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createevent.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update event
      .addCase(updateevent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateevent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateevent.rejected, (state, action) => {
      state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete event
      .addCase(deleteevent.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteevent.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteevent.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
    updateFilterData,
    setFilterData,
  setEvent,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize
 } = eventSlice.actions;
export default eventSlice.reducer;
